<template lang="pug">
.mb-5
  .bulk-send-page
    bulk-send-step-bar(:step='1')
    //- start warning no credits
    .alert.alert-warning.alert-dismissible.fade.show(
      role='alert'
      v-if='dontHaveCredits'
    )
      div(style='display: flex; align-items: center')
        icon.icon-left(name='circle-exclamation')
        span(style='font-weight: bold; margin-right: 10px')
          | {{ $t('modal.envelope.selectDocuments.creditsLimit', { planIntervalName }) }}
        button.close(
          aria-label='Close'
          data-bs-dismiss='alert'
          type='button'
        )
          span &times
      div
        | {{ $t('modal.envelope.selectDocuments.waitRenewal') }}
        |
        button.btn-link-menu(type='button')
          router-link.plan-details-link(
            :to='{ name: "account.billing.plan", query: { tab: "plans" } }'
          ) {{ $t('modal.envelope.selectDocuments.upgradePlan') }}
        |
        | {{ $t('modal.envelope.selectDocuments.continueSending') }}
        //- end warning no credits]
    .row(v-if='!showFeedbackNoTemplates')
      .mb-3.col-12.col-lg-6.col-xl-5
        .form-control-icon--end-line.flex-grow-1
          input.form-control.rounded-3(
            :placeholder='$t("placeholder.search_envelopes")'
            @input='searchTemplate()'
            autocomplete='off'
            v-model='filters.search'
          )
          icon.icon--blue.font-size-subtitle(name='magnifying-glass')
      .mb-3.col-12.col-lg-6.col-xl-7
        .text-end
          button.btn.btn-primary(@click='createEnvelopeForTemplate') {{ $t('newTemplate') }}
    .row(v-if='hasTemplate')
      .col-12
        bulk-send-template-envelopes-card-table.mb-5(
          :data='templatesList.data'
          :disableRadio='false'
          :selected='selectedTemplate.id'
          @selected='selectTemplate($event)'
        )
        simple-paginator(:payload='templatesList' @navigate='loadTemplates')
    .text-center.mt-5(v-if='showFeedbackNoTemplates')
      img.img(
        src='/img/ilustrations/no-document-template.svg'
        style='max-height: 260px'
      )
      .mt-4.text-center {{ $t('message.no_envelopes_template') }}<br>{{ $t('message.no_envelopes_template_3') }}
      .mt-4.text-center
        button.btn.btn-primary(@click='createEnvelopeForTemplate') {{ $t('newTemplate') }}

    envelope-bottom-bar.bulk-send-page__bottom-bar(
      :disableButtonNextStep='disabledNextStep'
      :discardAndClose='false'
      @discardAndClose='discardChanges'
      @nextStep='next'
      @saveAndClose='saveAndClose'
      v-if='hasTemplate'
    )

    warning-save-and-close-bulk-send-modal(
      @discardChanges='discardChanges'
      @saveAndClose='saveAndClose'
      ref='saveAndCloseModal'
    )
      p.mb-0 {{ $t('configureBulkSend.confirmDiscard') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import TopPageBar from '@/ui/organisms/TopPageBar.vue';
// eslint-disable-next-line max-len
import ToastAlert from '@/modules/account/common/alert';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import BulkSendStepBar from '@/ui/organisms/BulkSendStepBar.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import alert from '@/modules/account/common/alert';
import debounce from 'debounce';
import BulkSendTemplateEnvelopesCardTable from '@/modules/business/components/organisms/card-table/BulkSendTemplateEnvelopesCardTable.vue';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
import WarningSaveAndCloseBulkSendModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseBulkSend.vue';

export default {
  name: 'BulkSendSelectTemplate',
  components: {
    WarningSaveAndCloseBulkSendModal,
    SimplePaginator,
    BulkSendStepBar,
    Icon,
    TopPageBar,
    ToastAlert,
    EnvelopeBottomBar,
    BulkSendTemplateEnvelopesCardTable,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'business.bulk-send.recipients' ||
      to.name === 'business.bulk-send.template' ||
      to.name === 'business.documents.bulk-send'
    ) {
      next();
      return;
    }
    this.$refs.saveAndCloseModal.$refs.modal.open();
    this.nextRoute = next;
  },
  data() {
    return {
      nextRoute: null,
      templatesList: {
        data: [],
        meta: {},
        links: {},
      },
      filters: {
        search: '',
        sort: '-created_at',
      },
      selectedTemplate: {},
      bulkSend: {},
      bulkSendId: null,
      hasError: false,
    };
  },
  async created() {
    this.updatePageTitleAndHead();
    this.bulkSendId = this.$route.params.id ?? null;
    await this.loadTemplates();
  },
  async beforeMount() {
    if (
      !this.$route.params.back &&
      (!this.isNew || (this.$route.params.id && this.bulkSendId))
    ) {
      await this.$router.replace({
        name: 'business.bulk-send.recipients',
        params: {
          id: this.bulkSendId,
          isNew: false,
          editDraftBulkSend: this.isEditingDraft,
        },
      });
      return;
    }
  },
  computed: {
    isNew() {
      return this.$route.params.isNew === true || !this.$route.params.id;
    },
    isEditingDraft() {
      return this.$route.query.editDraftBulkSend === 'true';
    },
    isBack() {
      return this.$route.params.back === true;
    },
    disabledNextStep() {
      return !this.selectedTemplate?.id || this.hasError;
    },
    getPageTitle() {
      return this.isNew ? this.$t('newBulkSend') : this.$t('editBulkSend');
    },
    hasTemplate() {
      return this.templatesList.data.length > 0;
    },
    isSearching() {
      return this.filters.search.length > 0;
    },
    showFeedbackNoTemplates() {
      return !this.hasTemplate;
    },
    showFeedbackNoResults() {
      return this.isEmptyList && this.isSearching;
    },
    dontHaveCredits() {
      return !this.$store.getters['subscription/hasCredits'];
    },
    planIntervalName() {
      switch (this.$store.state.subscription.plan?.plan?.interval) {
        case 1:
          return this.$t('pages.planDetails.planInterval.1');
        case 6:
          return this.$t('pages.planDetails.planInterval.6');
        case 12:
          return this.$t('pages.planDetails.planInterval.12');
        default:
          return this.$t('pages.selectDocuments.cycle');
      }
    },
  },
  methods: {
    updatePageTitleAndHead() {
      const pageTitle = this.getPageTitle;
      this.$store.dispatch('page/setTitle', pageTitle);
      this.$store.dispatch('page/setHead', {
        title: pageTitle,
      });
    },
    async next() {
      if (this.isNew && !this.bulkSendId) {
        await this.createBulkSend();
      }

      if (!this.bulkSendId || this.hasError) {
        return;
      }

      // TODO update bulk-send for change templates in future version

      if (this.nextRoute) {
        this.nextRoute();
        return;
      }

      // next step
      await this.$router.replace({
        name: 'business.bulk-send.recipients',
        params: {
          id: this.bulkSendId,
          isNew: this.isNew,
        },
      });
    },
    async saveAndClose() {
      if (this.isNew) {
        await this.createBulkSend();
      }
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.push({ name: 'business.documents.bulk-send' });
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    selectTemplate(template) {
      this.selectedTemplate = template;
      this.hasError = false;
    },
    async loadTemplates(page = 1) {
      this.$loading(true);
      this.hasError = false;
      this.templatesList.data = [];
      const params = new URLSearchParams({
        ...{ extended: true },
        ...(this.filters.search && { q: this.filters.search }),
        ...{ page },
        ...{ 'filter[state]': 'template' },
        ...{ sort: this.filters.sort },
      });
      EnvelopesService.listSent(params.toString())
        .then((response) => {
          this.templatesList = response.data;
        })
        .catch((error) => {
          this.hasError = true;
          alert.fireAlert(
            `${this.$t('modal.envelope.templateEnvelopeError')} ${
              error.response.data.message
            }`,
            {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
              tag: 'httpAlert',
              icon: 'triangle-exclamation',
            }
          );
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    searchTemplate: debounce(function searchTemplate() {
      this.loadTemplates();
    }, 300),
    async createBulkSend() {
      this.$loading(true);
      this.hasError = false;
      await EnvelopesService.createNewBulkSend({
        envelope: this.selectedTemplate.id,
        name: this.selectedTemplate.title,
      })
        .then((response) => {
          this.bulkSendId = response.data.uuid;
        })
        .catch((error) => {
          this.hasError = true;
          const errorMessage = `${this.$t(
            'configureBulkSend.error.saveBulkSend'
          )} ${error.response.data.message}`;
          alert.fireAlert(errorMessage, {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async createEnvelopeForTemplate() {
      this.$loading(true);
      this.hasError = false;
      await EnvelopesService.create({
        title: this.$t('newTemplate'),
        state: 'template',
        metadata: {},
      })
        .then((response) => {
          this.$router.replace({
            name: 'business.envelope.documents',
            params: {
              id: response.data.id,
              isTemplate: true,
              isNewTemplate: true,
            },
          });
        })
        .catch((error) => {
          this.hasError = true;
          const errorMessage = `${this.$t(
            'templateEnvelopesCardTable.error.saveTemplate'
          )} ${error.response.data.message}`;
          alert.fireAlert(errorMessage, {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.bulk-send-page
  display: flex
  flex-direction: column
  min-height: calc(100vh - 240px)
.bulk-send-page__bottom-bar
  margin-top: auto !important
  padding-top: 1.5rem
  flex-shrink: 0
.w-center
  margin: auto
  max-width: 960px
.card--file-loader
  text-align: center
  border: 2px dashed #3ECB90
  color: #013D52
  padding: 1rem
  box-shadow: 0 3px 5px #00000029
  &:hover
    background-color: #eaeaea
  .card-title
    font-size: 1.5rem
  .btn
    padding-left: 1rem
    padding-right: 1rem
  .dragenterClass
    cursor: grabbing
    cursor: -webkit-grabbing
    background:rgba(0,0,0,0.1)
    .notclickable
      pointer-events: none
      h3
        pointer-events: none
      p
        pointer-events: none
.btn-link-menu
  font-size: 1rem
  text-decoration: underline
  color: #0080a3 !important
  padding: 0

  .plan-details-link
    color: inherit
    text-decoration: none

    &:visited, &:hover, &:active
      color: inherit
      text-decoration: none
</style>
